export default "__VITE_ASSET__DnStf9RQ__"